import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AssociateDashboard } from "@/components/associate/AssociateDashboard";
import { MonthlyTable } from "@/components/associate/MonthlyTable";
import { OwnershipReadiness } from "@/components/roadmap/AssociateMilestones";

const NAMES = { associate: "Associate Agent Program", protege: "Protégé Agency Producer Program" };

export default function PortalAssociate({ goTo, prog = "associate" }) {
  const [data, setData] = useState(null);
  const [reqs, setReqs] = useState(null);
  useEffect(() => { api.get(`/${prog}-bonus/me`).then((r) => setData(r.data)).catch(() => setData({ enrolled: false })); }, [prog]);
  useEffect(() => {
    if (prog === "associate") { api.get("/portal/milestones").then((r) => setReqs(r.data.applicable ? r.data.requirements : null)).catch(() => setReqs(null)); }
  }, [prog]);
  if (!data) return <p className="text-sm text-slate-400">Loading…</p>;
  if (!data.enrolled) return <p className="text-sm text-slate-500" data-testid="abp-not-enrolled">This dashboard is available once you're enrolled in the {NAMES[prog]}.</p>;
  const monthly = (
    <>
      <MonthlyTable data={data} onData={setData} />
      {reqs && <OwnershipReadiness reqs={reqs} rows={data.rows} />}
    </>
  );
  return <AssociateDashboard data={data} candidate onTasks={() => goTo("journey", "training")} monthly={monthly} />;
}
